import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen" }


export default /*@__PURE__*/_defineComponent({
  __name: 'legacy-qr-redirect',
  setup(__props) {

definePageMeta({
  layout: 'public',
  auth: false,
})

const route = useRoute()
const { redirectByToken } = useLegacyQrRedirect()

onMounted(async () => {
  const token = route.params.token as string

  if (!token) {
    await navigateTo('/admin/dashboard', { replace: true })
    return
  }

  await redirectByToken(token)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "text-center" }, [
      _createElementVNode("div", { class: "spinner" }),
      _createElementVNode("p", { class: "mt-4 text-gray-600" }, "Redirecting...")
    ], -1)
  ]))]))
}
}

})